import iconOne from '../../assets/features/1.png';
import iconTwo from '../../assets/features/2.png';
import iconThree from '../../assets/features/3.png';
import iconFour from '../../assets/features/4.png';

const featuresData = [
    {
        'icon': iconOne,
        'title': 'Önce güvenlik',
        'description': 'Sağlık kontrolleri ve sterilizasyon süreçleriyle güvenliği önceliklendiriyoruz.'
    },
    {
        'icon': iconTwo,
        'title': 'Esnek ödeme seçenekleri',
        'description': 'Farklı bütçelere uygun ödeme planlarıyla tedavi sürecinizi kolaylaştırıyoruz.'
    },
    {
        'icon': iconThree,
        'title': 'Kapsamlı diş hekimliği',
        'description': 'Muayeneden implant ve estetik uygulamalara kadar geniş kapsamlı hizmet sunuyoruz.'
    },
    {
        'icon': iconFour,
        'title': 'Yargısız yaklaşım',
        'description': 'Ağız ve diş sağlığı geçmişiniz ne olursa olsun sizi anlayışla karşılıyoruz.'
    }
]

export default featuresData;